const elemRE = document.querySelectorAll('.wt-RelatedEntries');
window.fireOnVisible(elemRE, async () => {
    await import('./assets/css/related_entries.scss');
});
